import StaffMemberFilterView from '@UI/Pages/Agencies/StaffMembers/Filters/StaffMemberFilterView';
import { createSignal } from '@verclam/pulsar';

const staffMemberFiltersSignal = createSignal<StaffMemberFilterView>(StaffMemberFilterView.createDefault());

export const setStaffMemberFilters = (filters: StaffMemberFilterView): void => {
	staffMemberFiltersSignal.value = filters;
};

export default staffMemberFiltersSignal;
